/** WHAT'S NEW TOAST — post-login card for unread published release notes: Got it · Learn more · Don't show again. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, X } from "lucide-react";

export default function WhatsNewToast({ user }) {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!user || user.requires_legal_acceptance || user.must_change_password) return;
    let dead = false;
    const t = setTimeout(() => api.get("/product-feedback/whats-new/pending").then(({ data }) => { if (!dead) setItems(data.items || []); }).catch(() => {}), 1500);
    return () => { dead = true; clearTimeout(t); };
  }, [user]);
  if (!items.length) return null;
  const e = items[0];
  const ack = async () => { setItems((xs) => xs.slice(1)); try { await api.post("/product-feedback/whats-new/ack", { entry_ids: [e.id] }); } catch { /* best effort */ } };
  const learn = async () => { await ack(); navigate("/whats-new"); };
  const mute = async () => { setItems([]); try { await api.post("/product-feedback/whats-new/mute?muted=true"); } catch { /* best effort */ } };
  return (
    <div className="fixed bottom-20 md:bottom-5 right-5 z-panel w-[360px] max-w-[calc(100vw-2rem)] rounded-2xl bg-[#0F1420] text-white shadow-2xl p-4 os-fade-in" data-testid="whats-new-toast">
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-xl bg-white/10 grid place-items-center shrink-0"><Sparkles className="h-4 w-4" /></div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-white/60">What's new{items.length > 1 ? ` · ${items.length} updates` : ""}</div>
          <div className="text-[14px] font-semibold leading-snug mt-0.5" data-testid="whats-new-toast-title">{e.title}</div>
          {e.summary && <div className="text-[12px] text-white/70 mt-1 line-clamp-3">{e.summary}</div>}
        </div>
        <button onClick={ack} className="h-7 w-7 grid place-items-center rounded-md hover:bg-white/10" aria-label="Dismiss" data-testid="whats-new-toast-close"><X className="h-4 w-4" /></button>
      </div>
      <div className="flex items-center gap-2 mt-3">
        <button onClick={ack} className="h-8 px-3 rounded-full bg-white text-[#0F1420] text-[12px] font-semibold hover:brightness-95" data-testid="whats-new-toast-gotit">Got it</button>
        <button onClick={learn} className="h-8 px-3 rounded-full border border-white/25 text-[12px] font-medium hover:bg-white/10" data-testid="whats-new-toast-learn">Learn more</button>
        <button onClick={mute} className="ml-auto text-[11px] text-white/60 hover:text-white underline-offset-2 hover:underline" data-testid="whats-new-toast-mute">Don't show again</button>
      </div>
    </div>
  );
}
